import React, { useState, useRef, useEffect } from "react";
import { useNotifs } from "./NotifContext";

const TYPE_CFG = {
  success: { bg: "#EAF3DE", color: "#3B6D11", icon: "✅" },
  error:   { bg: "#FCEBEB", color: "#A32D2D", icon: "❌" },
  warning: { bg: "#FAEEDA", color: "#854F0B", icon: "⚠️" },
  info:    { bg: "#E6F1FB", color: "#185FA5", icon: "ℹ️" },
};

export default function NotifBell() {
  const { notifs, dismiss, clearAll } = useNotifs();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const unread = notifs.length;

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button onClick={() => setOpen(o => !o)}
        style={{ position: "relative", background: "none", border: "none", cursor: "pointer", padding: "4px 6px", borderRadius: 8, display: "flex", alignItems: "center" }}>
        <span style={{ fontSize: 20 }}>🔔</span>
        {unread > 0 && (
          <span style={{
            position: "absolute", top: 0, right: 0,
            background: "#A32D2D", color: "#fff",
            borderRadius: "50%", width: 16, height: 16,
            fontSize: 9, fontWeight: 700,
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "2px solid #f5f5f5",
          }}>
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 8px)", right: 0,
          width: 320, background: "#fff", borderRadius: 12,
          boxShadow: "0 8px 32px rgba(0,0,0,0.14)", border: "1px solid #eee",
          zIndex: 1000, overflow: "hidden", animation: "fadeInDown 0.2s ease",
        }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid #f0f0f0" }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#222" }}>🔔 Notifications</span>
            {notifs.length > 0 && (
              <button onClick={clearAll}
                style={{ background: "none", border: "none", fontSize: 11, color: "#aaa", cursor: "pointer", fontWeight: 500 }}>
                Tout effacer
              </button>
            )}
          </div>

          <div style={{ maxHeight: 360, overflowY: "auto" }}>
            {notifs.length === 0 ? (
              <div style={{ padding: "32px 16px", textAlign: "center", color: "#bbb", fontSize: 13 }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>🔕</div>
                Aucune notification
              </div>
            ) : (
              notifs.map(n => {
                const cfg = TYPE_CFG[n.type] || TYPE_CFG.info;
                const timeStr = n.time.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
                return (
                  <div key={n.id} style={{
                    display: "flex", alignItems: "flex-start", gap: 10,
                    padding: "10px 16px", borderBottom: "1px solid #f8f8f8",
                    background: cfg.bg + "55",
                  }}>
                    <span style={{ fontSize: 16, flexShrink: 0, marginTop: 1 }}>{cfg.icon}</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 12, color: "#333", lineHeight: 1.4 }}>{n.msg}</div>
                      <div style={{ fontSize: 10, color: "#bbb", marginTop: 3 }}>{timeStr}</div>
                    </div>
                    <button onClick={() => dismiss(n.id)}
                      style={{ background: "none", border: "none", cursor: "pointer", color: "#ccc", fontSize: 14, padding: "0 2px", flexShrink: 0 }}>
                      ×
                    </button>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
